var map = {
	"./about-image-1.jpg": "64ee",
	"./aboutme.png": "a56a",
	"./bg-grey-scratch.png": "ea8e",
	"./bkg-facelift-girl.png": "28c9",
	"./bkg-rhino-girl.png": "1751",
	"./body-1.jpg": "5798",
	"./boxes-shadow.png": "5fce",
	"./bubbles1.png": "94e0",
	"./bubbles2.png": "9af2",
	"./contact.png": "9fa8",
	"./feat-gallery-1.jpg": "d67d",
	"./feat-media.jpg": "53b4",
	"./feat-patient-stories.jpg": "aae5",
	"./grey-media.jpg": "867e",
	"./logo-footer-01.jpg": "49e1",
	"./logo-footer-02.jpg": "625b",
	"./logo-footer-03.jpg": "f6e0",
	"./logo-footer-04.jpg": "e24c",
	"./logo-footer-05.jpg": "f730",
	"./logo.ORIGINAL.png": "b312",
	"./logo.png": "cf05",
	"./nav-girl-3.png": "62a5",
	"./nav-patient.png": "070a",
	"./nav-patient_ORIGINAL.png": "73f4",
	"./project1.jpeg": "ad38",
	"./project2.jpeg": "d3f4a",
	"./project3.jpeg": "9334",
	"./project4.jpeg": "11ac",
	"./recentprojects.png": "1b19",
	"./services.png": "67e9",
	"./welcome.png": "5d18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";